import { FC, useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import useThread from '@/hooks/use-thread.hook';
import Tile from '.';
import AgentBadge from '@/components/agent-badge';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { BaseTileProps } from './helpers';
import { useQuery } from 'react-query';
import { getAllThreads } from '@/lib/services/thread.service';
import { QueryKey } from '@/lib/query-client';
import { Stack } from '@mui/material';
import Icon from '@/components/icon';
import Text from '@/components/text';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  conversationTitle: {
    gap: 6,
    '& .chat-icon': {
      marginTop: 3,
    },
  },
});

const ConversationTile: FC<BaseTileProps> = (props) => {
  const { tile } = props;
  const { agents } = useUserSettings();
  const { resourceId: threadId, serviceId: agentId } = tile;
  const styles = useStyles();

  const { data: threads = [] } = useQuery([QueryKey.ThreadsList], async () => getAllThreads());

  const thread = useMemo(() => {
    return threads.find(({ id }) => id === threadId);
  }, [threads, threadId]);

  const agent = useMemo(() => {
    return agents.find(({ id }) => id === agentId);
  }, [agents, agentId]);

  const title = useMemo(() => {
    return thread?.latestUserMessage?.content || agent?.portal?.badge?.title || 'Assistant';
  }, [thread, agent]);
  const ImageEl = <AgentBadge agent={agent} />;

  const { loadThread } = useThread();
  const navigate = useNavigate();

  const handleClick = () => {
    loadThread(threadId).then((loaded) => {
      if (!loaded) {
        return;
      }

      navigate({ to: '/chat/$threadId', params: { threadId } });
    });
  };

  const TitleEl = (
    <Stack direction="row" alignItems="center" maxWidth="100%" className={styles.conversationTitle}>
      <Icon name="ai-chat" size="small" className="chat-icon" />
      <Text size="small" dotdot>
        {title}
      </Text>
    </Stack>
  );

  return <Tile onClick={handleClick} title={TitleEl} icon={ImageEl} {...props} dotdot />;
};

export default ConversationTile;
